import React from "react";
import { Row, Col } from "react-bootstrap";

const Block = ({ height = 38, width = "100%" }) => (
  <span
    className="d-block rounded-2 mb-1"
    style={{
      height,
      width,
      background: "linear-gradient(90deg,#eceff1 25%,#f5f6f7 37%,#eceff1 63%)",
      backgroundSize: "400% 100%",
      animation: "tmShimmer 1.4s ease infinite",
    }}
  />
);

/**
 * FormSkeleton — page-level placeholder shown while an Add/Edit/View
 * page's initial data is loading, so the layout never flashes an empty
 * card or a full-page spinner. `fields` controls how many label+input
 * placeholder pairs render per row; `images` adds a row of square
 * image-upload placeholders.
 */
const FormSkeleton = ({ fields = 4, images = 0, rows = 1 }) => (
  <div className="border rounded-3 p-3">
    {Array.from({ length: rows }).map((_, r) => (
      <Row key={r} className="mb-2">
        {Array.from({ length: fields }).map((__, i) => (
          <Col lg={12 / fields} sm={6} key={i} className="mb-3">
            <Block height={12} width="40%" />
            <Block height={38} />
          </Col>
        ))}
      </Row>
    ))}
    {images > 0 && (
      <Row>
        {Array.from({ length: images }).map((_, i) => (
          <Col lg={12 / images} sm={6} key={i} className="mb-3">
            <Block height={12} width="50%" />
            <Block height={100} />
          </Col>
        ))}
      </Row>
    )}
    <style>{`@keyframes tmShimmer{0%{background-position:100% 50%}100%{background-position:0 50%}}`}</style>
  </div>
);

export default FormSkeleton;
